export const teamsSelector = (state) => state.teams;
